import { ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { DeclareCsiDivisionsManager } from '../../../utilities/DeclareCsiDivision'
import "./styles.css"
import { QuestionType } from '../../../store/Models/Surveys/SurveyDataModel';
import { ToxnotSignInRequiredComponent } from "../BaseApplicationComponents/ToxnotSignInRequiredComponent";
import { TeamRole } from '../../../store/Models/UserContext';
import MarkdownRenderer from '../MarkdownRenderer/MarkdownRenderer';

interface DynamicQuestionProps extends ToxnotComponentProperties {
    questionText: string,
    type: string,
    answerOptions: string[],
    selectedOptions?: (string | undefined)[],
    instructionText?: string,
}

export class DynamicQuestion extends ToxnotSignInRequiredComponent<DynamicQuestionProps> {
    public constructor(props: DynamicQuestionProps) {
        super(props);
    }

    private renderContent() {
        switch (this.props.type) {
            case QuestionType.MultipleDropdown:
                return this.renderDropDown(["--"].concat(this.props.answerOptions));
            case QuestionType.DataTable:
                return this.renderDataTable(this.props.answerOptions);
            case QuestionType.MultiCheckbox:
            case QuestionType.Attestation:
                return this.renderCheckbox(this.props.answerOptions);
            case QuestionType.Multiple:
                return this.renderRadioButtons(this.props.answerOptions);
            case QuestionType.Text:
            case QuestionType.ImageUrl:
            case QuestionType.Url:
                return this.renderText();
            case QuestionType.MultiText:
                return this.renderMultiText();
            case QuestionType.Comment:
                return this.renderTextArea();
            case QuestionType.Datetime:
                return this.renderDatetime();
            case QuestionType.File:
                return this.renderButtonWithPlusIcon(this.localizeString("Add Document"));
            case QuestionType.CsiDivision:
                return this.renderDropDown(DeclareCsiDivisionsManager.declareCsiDivisions.map(d => d.name));
            case QuestionType.ScipArticleCategory:
                return this.renderButton(this.localizeString("Add EU ECHA Article Category"));
            case QuestionType.ScipArticleIdentifier:
                return this.renderScipIdentifier();
            case QuestionType.CmrtComplianceAnswer:
                return this.renderCmrtComplianceAnswer(["Tantalum (Ta)", "Tin (Sn)", "Gold (Au)", "Tungsten (W)"]);
            case QuestionType.CmrtCompanyQuestionAnswer:
                return this.renderCmrtComplianceAnswer(["Answer"]);
            case QuestionType.CheckboxAndComment:
                return this.renderCheckboxAndComment(this.props.answerOptions);
            default:
                return null;
        }
    };

    private renderDropDown(answers: string[]) {
        return (
            <select disabled className="form-control">
                {
                    answers.map((value, i) => <option key={i} selected={this.props.selectedOptions?.includes(value)}>{value}</option>)
                }
            </select>
        )
    }

    private renderDropdownAndCommentt(answers: string[]) {
        return (
            <div>
                {
                    answers.map((value, i) =>
                        <div className="form-group col-xs-3">
                            <label>Answer</label>
                            <select disabled className="form-control">
                                {
                                    answers.map((value, i) => <option key={i} selected={this.props.selectedOptions?.includes(value)}>{value}</option>)
                                }
                            </select>
                        </div>
                    )
                }
            </div>
        )
    }
    private renderRadioButtons(answers: string[]) {
        return (
            <div>
                {
                    answers.map((value, i) =>
                        <div key={i} className="radio disabled">
                            <label>
                                <input type="radio" disabled checked={this.props.selectedOptions?.includes(value)} />
                                <MarkdownRenderer htmlText={value.replace('<', '\\<').replace('>', '\\>')} />
                            </label>
                        </div>
                    )
                }
            </div>
        )
    }

    private renderCheckbox(answers: string[]) {
        return (
            <div>
                {
                    answers.map((value, i) =>
                        <div key={i} className="checkbox disabled">
                            <label>
                                <input type="checkbox" disabled checked={this.props.selectedOptions?.includes(value)} />{value}
                            </label>
                        </div>
                    )
                }
            </div>
        )
    }

    private renderCheckboxAndComment(answer: string[]) {
        return <>
            {this.renderCheckbox(answer)}
            {this.renderTextArea()}
        </>
    }

    private renderDropdownAndComment(answer: string[]) {
        return <>
            {this.renderDropDown(answer)}
            {this.renderTextArea()}
        </>
    }

    private renderDataTable(answers: string[]) {
        return (
            <div>
                {this.renderButton(this.localizeString("Add New Row"))}
                <table className="table">
                    <thead>
                        <tr>
                            {
                                answers.map((value, i) => <th key={i}>{value}</th>)
                            }
                        </tr>
                    </thead>
                    <tbody></tbody>
                </table>
            </div>
        )
    }

    private renderTextArea() {
        return <textarea className="form-control" disabled></textarea>
    }

    private renderText(placeholderText?: string) {
        return <input type="text" className="form-control" disabled placeholder={placeholderText}></input>
    }

    private renderDatetime() {
        return <input type="date" className="form-control" disabled />
    }

    private renderButton(localizedText: string) {
        return <button className="btn btn-default" disabled>{localizedText}</button>
    }

    private renderButtonWithPlusIcon(localizedText: string) {
        return <button className="btn btn-default" disabled><span className="glyphicon glyphicon-plus"></span>{localizedText}</button>
    }

    private renderMultiText() {
        return (
            <div>
                {this.renderText()}
                <div className="m-t-5">
                    {this.renderButton(this.localizeString("Add New Answer"))}
                </div>
            </div>
        )
    }

    private renderScipIdentifier() {
        return (
            <div className="form-inline">
                {this.renderDropDown([this.localizeString("Identifier Type")])}
                {" "}
                {this.renderText(this.localizeString("Identifier"))}
            </div>
        )
    }

    protected getDisallowedRoles(): TeamRole[] {
        return [TeamRole.Marketing, TeamRole.Viewer];
    }

    protected renderConcreteComponent(): JSX.Element | null {
        return (
            <div className="group">
                <div className="title">
                    {this.props.questionText}
                </div>
                <div className="content">
                    {this.props.instructionText &&
                        <div className="panel-body">
                            <MarkdownRenderer htmlText={this.props.instructionText ?? ""} />
                        </div>
                    }
                    {this.renderContent()}
                </div>

            </div>
        );
    }
    private renderCmrtComplianceAnswer(answers: string[]) {
        return (
            <div>
                {
                    answers.map((value, i) =>
                        <div key={i}>
                            <div key={value + i.toString()} className="form-group col-xs-3">
                                <label>{this.localizeString(value)}</label>
                                {this.renderDropDown(this.props.answerOptions)}
                            </div>
                            <div key={i} className="form-group col-xs-9">
                                <label>{this.localizeString("Comment")}</label>
                                {this.renderText(this.localizeString(""))}
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
}
